import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectTownsState } from '../selectors';

export const getData = createSelector(selectTownsState, (state: State) => state.data);

export const getError = createSelector(selectTownsState, (state: State) => state.error);

export const getLoading = createSelector(selectTownsState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectTownsState, (state: State) => fn(state.data));
